import React, { useRef, useState } from "react";
import "../styles/ChatbotIconStyles.css";
import chatBotIcon from "../images/chatBotIcon.svg";
import AiOverlayModal from "../components/AiOverLayModal";
import chatBotClose from "../images/chatBotCloseIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { setShowChatBotOnLogin, setChatBotMode } from "../../../store/networkListener";

const ChatBotIcon: React.FC = () => {
  // const [showModal, setShowModal] = useState(false);
  const showModalRedux = useSelector(
    (state: RootState) => state.network.showChatBotOnLogin,
  );
  const chatBotMode = useSelector(
    (state: RootState) => state.network.chatBotMode,
  );
  const floatingRef = useRef<HTMLDivElement>(null);

  const animateClose = () => {
    const start = floatingRef.current?.getBoundingClientRect();

    const end = document
      .getElementById("sidebar-chatbot")
      ?.getBoundingClientRect();

    if (!start || !end) {
      setShowModal(false);
      return;
    }

    const clone = floatingRef.current!.cloneNode(true) as HTMLElement;

    clone.style.position = "fixed";
    clone.style.left = `${start.left}px`;
    clone.style.top = `${start.top}px`;
    clone.style.width = `${start.width}px`;
    clone.style.height = `${start.height}px`;
    clone.style.zIndex = "99999";
    clone.style.pointerEvents = "none";

    document.body.appendChild(clone);

    floatingRef.current!.style.visibility = "hidden";

    requestAnimationFrame(() => {
      clone.style.transition = "all .7s cubic-bezier(.22,1,.36,1)";

      clone.style.left = `${end.left}px`;
      clone.style.top = `${end.top}px`;

      clone.style.transform = "scale(.65)";
      clone.style.opacity = "0.8";
    });

    clone.addEventListener("transitionend", () => {
      clone.remove();

      setShowModal(false);
      setShowFloatingBot(false); // Hide floating bot

      dispatch(setShowChatBotOnLogin(false));
      sessionStorage.setItem("floatingBotHidden", "true");
    });
  };

  const dispatch = useDispatch();
  const handleClick = () => {
    // This will later open the chat popup
    setShowModal(true);
  };
  const [showModal, setShowModal] = useState(false);
  const [showFloatingBot, setShowFloatingBot] = useState(() => {
    return sessionStorage.getItem("floatingBotHidden") !== "true";
  });
  return (
    <div>
      {showFloatingBot && (
        <div ref={floatingRef} className="chatbot-icon">
          <img
            src={chatBotIcon}
            className="chatbot-image"
            onClick={handleClick}
          />

          <div
            className="chatbot-close-btn"
            onClick={(e) => {
              e.stopPropagation();
              animateClose();
            }}
          >
            ✕
          </div>
        </div>
      )}
      <AiOverlayModal
        isOpen={showModal || showModalRedux === true}
        onClose={() => {
          setShowModal(false);
          dispatch(setShowChatBotOnLogin(false));
        }}
        mode={showModalRedux ? chatBotMode : "floating"}
      />
    </div>
  );
};

export default ChatBotIcon;
